export const isArray = (value) => {
    return Array.isArray(value);
};